import React from "react";

export default function InstagramIcon() {
  return (
    <svg width={17} height={16} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.5 0C6.329 0 6.056.01 5.203.048 4.35.088 3.769.222 3.26.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .92 2.76C.722 3.268.587 3.85.548 4.7.51 5.555.5 5.827.5 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372.854.039 1.126.048 3.299.048s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942.038-.853.048-1.125.048-3.298s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.74.42c-.51-.198-1.092-.333-1.943-.372C10.943.01 10.672 0 8.498 0h.003Zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485-.145.373-.319.64-.599.919-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002Zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92Zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217Zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334Z"
        fill="url(#instagramIcon)"
      />
      <defs>
        <linearGradient
          id="instagramIcon"
          x1={3.5}
          y1={0}
          x2={12}
          y2={16}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#405DE6" />
          <stop offset={0.151} stopColor="#5B51D8" />
          <stop offset={0.323} stopColor="#833AB4" />
          <stop offset={0.495} stopColor="#C13584" />
          <stop offset={0.646} stopColor="#E1306C" />
          <stop offset={0.802} stopColor="#F77737" />
          <stop offset={1} stopColor="#FFDC80" />
        </linearGradient>
      </defs>
    </svg>
  );
}
